import { telegramLoginAtom } from "@framework/auth/atoms";
import { TelegramOTPVerification } from "./TelegramOTPVerification";
import { TelegramPhoneInput } from "./TelegramPhoneInput";

export function TelegramLoginForm() {
  const telegramLogin = telegramLoginAtom.useValue();

  if (telegramLogin.isOTPSent) {
    return <TelegramOTPVerification />;
  }

  return <TelegramPhoneInput />;
}
